// Create a BroadcastChannel
const cartChannel = new BroadcastChannel('cart_channel');

// Function to update cart data across all tabs
function updateCartData(cartData) {
  console.log("Updating cart data in localStorage and broadcasting.");
  localStorage.setItem('cartData', JSON.stringify(cartData));
  cartChannel.postMessage(cartData);
}

// Function to handle cart updates from other tabs
cartChannel.onmessage = (event) => {
  const cartData = event.data;
  console.log("Received cart data from another tab:", cartData);
  localStorage.setItem('cartData', JSON.stringify(cartData));
  refreshButtonStatus(cartData);  // Update the UI as needed
};

// Function to refresh button status
function refreshButtonStatus(cart) {
  console.log("Refreshing button status with cart data:", cart);

  // Define the maximum number of sample products
  const maxSamples = 5;

  // Select the sample container and related elements
  const sampleContainer = document.querySelector('.sample-container');
  if (!sampleContainer) {
    console.log('Sample container not found.');
    return;
  }

  const sampleButton = sampleContainer.querySelector('.sample-button');
  if (!sampleButton) {
    console.log('Sample button not found.');
    return;
  }

  const sampleButtonText = sampleButton.querySelector('strong');
  if (!sampleButtonText) {
    console.log('Sample button text (strong) not found.');
    return;
  }

  const sampleButtonSpan = sampleButton.querySelector('span');
  if (!sampleButtonSpan) {
    console.log('Sample button span not found.');
    return;
  }

  const sampleProductIdMatch = sampleButton.getAttribute('onclick') ? sampleButton.getAttribute('onclick').match(/\d+/) : null;
  const sampleProductId = sampleProductIdMatch ? sampleProductIdMatch[0] : null;
  if (!sampleProductId) {
    console.log('Sample product ID not found.');
    return;
  }

  // Create a set to store unique sample product IDs
  const uniqueSamples = new Set();
  let productInCart = false;

  // Loop through cart items to count sample products
  cart.items.forEach((item) => {
    console.log('Item:', item.title, 'Handle:', item.handle);
    if (item.handle.endsWith('-s')) {
      uniqueSamples.add(item.variant_id);
      if (item.variant_id == sampleProductId) {
        productInCart = true;
      }
    }
  });

  console.log('Unique sample products in cart:', uniqueSamples.size);

  // Make the sample container visible after checking the logic
  sampleContainer.style.visibility = 'visible';

  // Check if the maximum number of samples has been reached
  if (uniqueSamples.size >= maxSamples && !productInCart) {
    // Display the max message and disable the button
    sampleButton.style.cursor = 'not-allowed';
    sampleButton.style.backgroundColor = '#b9b4b4';
    sampleButton.style.borderColor = '#a19f9f';
    sampleButton.style.color = "#FFFFFF";
    sampleButton.setAttribute('data-disabled', 'true');
    sampleButtonText.innerHTML = 'MAX SAMPLES REACHED';
    sampleButtonSpan.textContent = 'FREE 5 Samples + $9.99 Flat Rate shipping';
  } else if (productInCart) {
    // Display a message if the product is already in the cart
    sampleButton.style.cursor = 'not-allowed';
    sampleButton.style.backgroundColor = '#b9b4b4';
    sampleButton.style.borderColor = '#a19f9f';
    sampleButton.style.color = "#FFFFFF";
    sampleButton.setAttribute('data-disabled', 'true');
    sampleButtonText.innerHTML = 'Already in the cart!';
    sampleButtonSpan.textContent = 'FREE 5 Samples + $9.99 Flat Rate shipping';
  } else {
    // Enable the button
    sampleButton.style.cursor = 'pointer';
    sampleButton.style.backgroundColor = '';
    sampleButton.style.borderColor = '';
    sampleButton.style.color = '';
    sampleButton.removeAttribute('data-disabled');
    sampleButtonText.innerHTML = 'Get a sample<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="24px" height="24px"><path stroke-linecap="round" stroke-linejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"></path></svg>';
    sampleButtonSpan.textContent = 'FREE 5 Samples + $9.99 Flat Rate shipping';
  }
}

// Function to add item to cart
function addItem(id, quantity) {
  // Get the current cart data from localStorage
  const cartData = JSON.parse(localStorage.getItem('cartData')) || {};

  // Check if the item is a sample product by its ID
  const isSample = id => cartData.items.some(item => item.variant_id === id && item.handle.endsWith('-s'));

  // Check if the sample limit has been reached
  const maxSamples = 5;
  const uniqueSamples = new Set(cartData.items.filter(item => item.handle.endsWith('-s')).map(item => item.variant_id));
  console.log('Unique sample products in cart:', uniqueSamples.size);

  if (uniqueSamples.size >= maxSamples && isSample(id)) {
    console.log('Max samples reached, not adding more.');
    return;
  }

  // Create an items array with the item ID and quantity to be added
  let items = [{
      id: id,
      quantity: quantity
  }];
  
  // Send a POST request to the Shopify API to add the item to the cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
  })
  .then(response => response.json())
  .then(data => {
      if (data.status && data.status === 'error') {
          console.error('Error adding item to cart:', data.message);
          return;
      }
      // Update the localStorage with the new cart data
      theme.cart.getCartData().then(cartData => {
        updateCartData(cartData);  // Update cart data and broadcast to other tabs
        // Dispatch a 'cart:build' event to rebuild the cart
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }).catch(error => {
        console.error('Error getting cart data:', error);
      });
  })
  .catch(error => {
      console.error('Error adding item to cart:', error);
  });
}

// Function to remove item from cart
function removeItem(id) {
  // Create an updates object with the item ID set to 0 (removing the item)
  let updates = {};
  updates[id] = 0;
  
  // Send a POST request to the Shopify API to update the cart
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => response.json())
  .then(data => {
    // Update the localStorage with the new cart data
    theme.cart.getCartData().then(cartData => {
      updateCartData(cartData);  // Update cart data and broadcast to other tabs
      // Dispatch a 'cart:build' event to rebuild the cart
      document.dispatchEvent(new CustomEvent('cart:build'));
      // Refresh the button status
      refreshButtonStatus(cartData);
    }).catch(error => {
      console.error('Error getting cart data:', error);
    });
  })
  .catch(error => {
    console.error('Error removing item from cart:', error);
  });
}

// Initial setup to load and synchronize cart data on page load
document.addEventListener('DOMContentLoaded', function() {  
  // Get the cart data and refresh the button status
  theme.cart.getCartData().then((cartData) => {
    if (!cartData) {
      return;
    }

    localStorage.setItem('cartData', JSON.stringify(cartData));
    refreshButtonStatus(cartData);
  }).catch((error) => {
    console.error("Error getting cart data:", error);
  });

  // Modify the onclick event to use addItem function
  const sampleContainer = document.querySelector('.sample-container');
  const sampleButton = sampleContainer ? sampleContainer.querySelector('.sample-button') : null;

  if (sampleButton) {
    sampleButton.onclick = (event) => {
      event.preventDefault();

      // Check if the button is already disabled
      if (sampleButton.getAttribute('data-disabled') === 'true') {
        return;
      }

      // Disable the button immediately after click
      sampleButton.style.cursor = 'not-allowed';    
      sampleButton.setAttribute('data-disabled', 'true');

      // Add the product to the cart using the addItem function
      const sampleProductId = sampleButton.getAttribute('onclick').match(/\d+/)[0];
      addItem(sampleProductId, 1);

      // Get the cart data and refresh the button status
      theme.cart.getCartData().then((cartData) => {
        refreshButtonStatus(cartData);
      }).catch((error) => {
        console.error("Error getting cart data:", error);
      });
    };
  } else {
    console.log('Sample button not found during initial setup.');
  }

  // Listen for the 'ajaxProduct:added' event to refresh the button status
  document.addEventListener('ajaxProduct:added', () => {
    console.log("ajaxProduct:added event received.");
    theme.cart.getCartData().then((cartData) => {
      localStorage.setItem('cartData', JSON.stringify(cartData));
      refreshButtonStatus(cartData);
    }).catch((error) => {
      console.error("Error getting cart data:", error);
    });
  });

  // Listen for the 'cart:build' event to refresh the button status
  document.addEventListener('cart:build', () => {
    console.log("cart:build event received.");
    theme.cart.getCartData().then((cartData) => {
      localStorage.setItem('cartData', JSON.stringify(cartData));
      refreshButtonStatus(cartData);
    }).catch((error) => {
      console.error("Error getting cart data:", error);
    });
  });
});
